export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'development';

export function isGovcloud() {
  return REACT_APP_ENV === 'govcloud_production' || REACT_APP_ENV === 'govcloud_stable';
}

export function isDevelopment() {
  return REACT_APP_ENV === 'development';
}
